import { useCallback } from "react";

import inputConnect from "./inputConnect";
import StringInput from "./StringInput";
import OptionInput from "./OptionInput";

const EmailWithConsentsInput = props => {
  const {
    fieldName,
    displayEmailConsent,
    consentLabel,
    value,
    consentGiven,
    updateValue
  } = props;

  const consentOption = { id: "email_consent", name: consentLabel };

  const handleUpdate = useCallback(
    (_formKey, _fieldName, data) => {
      const currentData = { value, consentGiven };
      const filteredData = {};

      if (typeof data.value !== "undefined") filteredData.value = data.value;
      if (typeof data.consentGiven !== "undefined") {
        filteredData.consentGiven = data.consentGiven;
      }

      updateValue({ ...currentData, ...filteredData });
    },
    [consentGiven, updateValue, value]
  );

  const handleConsentChange = useCallback(
    event => {
      updateValue({ value, consentGiven: event.target.checked });
    },
    [updateValue, value]
  );

  return (
    <div className="check-boxes">
      <StringInput
        fieldName={fieldName}
        defaultValue={value}
        onUpdate={handleUpdate}
        autoComplete="email"
      />

      {displayEmailConsent && (
        <div className="checkboxes-no-background margin-top-xs">
          <OptionInput
            type="checkbox"
            option={consentOption}
            name={fieldName}
            onChange={handleConsentChange}
            checked={!!consentGiven}
          />
        </div>
      )}
    </div>
  );
};

export default inputConnect(EmailWithConsentsInput, {
  fields: { value: "", consentGiven: false }
});
